export default "__VITE_ASSET__DCKHh1Sn__"